/*
 * @Author: Ashley.Liu
 * @Date: 2022-04-25 21:21:44
 * @LastEditTime: 2022-07-06 17:48:22
 * @Description: desc
 */
const baseIcon = 'iconfont '
export const adminMenu = [
  {
    index: '/dashboard',
    name: 'Dashboard',
    icon: baseIcon + 'icon-dashboard',
    children: [
      {
        index: '/dashboard/index',
        name: 'Dashboard'
      },
      {
        index: '/dashboard/monitor',
        name: 'Monitor'
      }
    ]
  },
  {
    index: '/data',
    name: 'Data',
    icon: baseIcon + 'icon-topic',
    children: [
      {
        index: '/dashboard/topic',
        name: 'Topic'
      },
      {
        index: '/data/task',
        name: 'Task',
        children: [
          {
            index: '/dashboard/task',
            name: 'Task'
          },
          {
            index: '/dashboard/trigger',
            name: 'Batch Trigger'
          },
          {
            index: '/dashboard/longTask',
            name: 'Long Task'
          }
        ]
      }
    ]
  },
  {
    index: '/monitor',
    name: 'Monitor',
    icon: baseIcon + 'icon-jobtitle',
    children: [
      {
        index: '/monitor/status',
        name: 'Status',
        children: [
          {
            index: '/dashboard/datacenter',
            name: 'Data Center'
          },
          {
            index: '/dashboard/zk',
            name: 'ZK'
          },
          {
            index: '/dashboard/status',
            name: 'channel',
            replaced: 'channel'
          },
          {
            index: '/dashboard/sentinel',
            name: 'Sentinel'
          }
        ]
      },
      {
        index: '/client',
        name: 'Client',
        children: [
          {
            index: '/dashboard/clientMap',
            name: 'Instance'
          },
          {
            index: '/dashboard/agent',
            name: 'Agent'
          },
          {
            index: '/dashboard/map',
            name: 'Map'
          }
        ]
      },
      {
        index: '/alarm',
        name: 'Alarm',
        children: [
          {
            index: '/dashboard/topicalert',
            name: 'Topic Alert'
          },
          {
            index: '/dashboard/monitorAlarm',
            name: 'Monitor Alarm'
          }
        ]
      }
    ]
  },
  {
    index: '/manage',
    name: 'Manage',
    icon: baseIcon + 'icon-channel',
    children: [
      {
        index: '/dashboard/request',
        name: 'Request'
      },
      {
        index: '/dashboard/user',
        name: 'User'
      },
      {
        index: '/manage/topic',
        name: 'Topic',
        children: [
          {
            index: '/dashboard/manage/topictemplate',
            name: 'Topic Template'
          },
          {
            index: '/dashboard/collection',
            name: 'Collection'
          },
          {
            index: '/dashboard/migratingTopic',
            name: 'Migration'
          }
        ]
      },
      {
        index: '/dashboard/job',
        name: 'Job'
      },
      {
        index: '/dashboard/channel',
        name: 'channel',
        replaced: 'channel'
      },
      {
        index: '/dashboard/monitorManage/alarmRule',
        name: 'Monitor Manage'
      },
      {
        index: '/dashboard/auditlog',
        name: 'Audit Log'
      }
    ]
  },
  {
    index: '/settings',
    name: 'Settings',
    icon: baseIcon + 'icon-Generateclientoffer',
    children: [
      {
        index: '/dashboard/group',
        name: 'Global Config'
      },
      {
        index: '/dashboard/nonAuthConfig',
        name: 'Public Config'
      },
      {
        index: '/dashboard/client',
        name: 'Client Param'
      },
      {
        index: '/dashboard/webhook',
        name: 'Webhook'
      },
      {
        index: '/dashboard/permission/menu',
        name: 'RBAC'
      },
      {
        index: '/dashboard/document',
        name: 'Document'
      }
    ]
  },
  {
    index: '/kafkaManage',
    name: 'Kafka Manage',
    icon: baseIcon + 'icon-configuration',
    children: [
      {
        index: '/dashboard/manage/dashboard',
        name: 'Dashboard'
      },
      {
        index: '/dashboard/manage/cluster',
        name: 'Cluster'
      },
      {
        index: '/dashboard/manage/describe/topic',
        name: 'Topic'
      },
      {
        index: '/dashboard/manage/describe/group',
        name: 'Consumer'
      },
      {
        index: '/dashboard/manage/reassign',
        name: 'Reassign'
      },
      {
        index: '/dashboard/manage/scram',
        name: 'SCRAM'
      },
      {
        index: '/dashboard/manage/token',
        name: 'Delegation Token'
      },
      {
        index: '/dashboard/manage/acl',
        name: 'ACL'
      },
      {
        index: '/dashboard/manage/alert',
        name: 'Alert'
      },
      {
        index: '/dashboard/manage/webhook',
        name: 'Webhook'
      },
      {
        index: '/dashboard/manage/cube',
        name: 'Cube Monitor'
      }
    ]
  },
  {
    index: '/dashboard/smart',
    name: 'Task Handler Platform',
    icon: baseIcon + 'icon-data'
  }
]
export const userMenu = [
  {
    index: '/dashboard',
    name: 'Dashboard',
    icon: baseIcon + 'icon-dashboard',
    children: [
      {
        index: '/dashboard/index',
        name: 'Dashboard'
      },
      {
        index: '/dashboard/monitor',
        name: 'Monitor'
      }
    ]
  },
  {
    index: '/data',
    name: 'Data',
    icon: baseIcon + 'icon-topic',
    children: [
      {
        index: '/dashboard/topic',
        name: 'Topic'
      },
      {
        index: '/data/task',
        name: 'Task',
        children: [
          {
            index: '/dashboard/task',
            name: 'Task'
          },
          {
            index: '/dashboard/trigger',
            name: 'Batch Trigger'
          },
          {
            index: '/dashboard/longTask',
            name: 'Long Task'
          }
        ]
      }
    ]
  },
  {
    index: '/monitor',
    name: 'Monitor',
    icon: baseIcon + 'icon-jobtitle',
    children: [
      {
        index: '/monitor/status',
        name: 'Status',
        children: [
          {
            index: '/dashboard/sentinel',
            name: 'Sentinel'
          },
          {
            index: '/dashboard/datacenter',
            name: 'Data Center'
          }
        ]
      },
      {
        index: '/client',
        name: 'Client',
        children: [
          {
            index: '/dashboard/clientMap',
            name: 'Instance'
          },
          {
            index: '/dashboard/agent',
            name: 'Agent'
          },
          {
            index: '/dashboard/map',
            name: 'Map'
          }
        ]
      },
      {
        index: '/alarm',
        name: 'Alarm',
        children: [
          {
            index: '/dashboard/topicalert',
            name: 'Topic Alert'
          },
          {
            index: '/dashboard/monitorAlarm',
            name: 'Monitor Alarm'
          }
        ]
      }
    ]
  },
  {
    index: '/manage',
    name: 'Manage',
    icon: baseIcon + 'icon-channel',
    children: [
      {
        index: '/dashboard/request',
        name: 'Request'
      },
      {
        index: '/dashboard/user',
        name: 'APP'
      },
      {
        index: '/dashboard/job',
        name: 'Job'
      },
      {
        index: '/dashboard/auditlog',
        name: 'Audit Log'
      }
    ]
  },
  {
    index: '/settings',
    name: 'Settings',
    icon: baseIcon + 'icon-Generateclientoffer',
    children: [
      {
        index: '/dashboard/client',
        name: 'Client Param'
      },
      {
        index: '/dashboard/document',
        name: 'Document'
      }
    ]
  },
  {
    index: '/kafkaManage',
    name: 'Kafka Manage',
    icon: baseIcon + 'icon-configuration',
    children: [
      {
        index: '/dashboard/manage/cluster',
        name: 'Cluster'
      }
    ]
  },
  {
    index: '/dashboard/smart',
    name: 'Task Handler Platform',
    icon: baseIcon + 'icon-data'
  }
]

export const microAPPMenu = [
  {
    index: '/dashboard/request',
    name: 'Request',
    icon: baseIcon + 'icon-jobtitle'
  }
]
